import { Outlet } from 'react-router-dom';

import useGoBack from '@/hooks/useGoBack';
import ProfileOptionsPageHeader from '@/shared-components/navigation/ProfileOptionsPageHeader';

import './styles/AdminArtist.css';

export default function Artists() {
  const goBackHandler = useGoBack("/profile");

  return (
    <>
      <div className="inventory-layout__page">
        <div className="inventory-layout__wrapper">
          <ProfileOptionsPageHeader title="Artists" onBack={goBackHandler} />

          <div className="inventory-layout__content">
            <Outlet/>
          </div>
        </div>
      </div>
    </>
  );
}
